import { PageLink } from '../../../../../assets/layout/core'

export const breadcrumbList: PageLink[] = [
  {
    title: 'Usuários',
    path: '/users',
    isSeparator: false,
    isActive: false
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false
  }
]
